import { render } from "./DishQuantity.vue?vue&type=template&id=7a5987e9"
import script from "./DishQuantity.vue?vue&type=script&lang=js"
export * from "./DishQuantity.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__